import {changeLoginType} from "./Actions";

let Maps={
    mapLoginTypeToProps:(state)=>{
        return {
            loginType:state.loginType
        }
    },
    mapLoginTypeDispatchToProps:(dispatch)=>{
        return {
            changeLoginType: (program) => {
                dispatch({
                    type: changeLoginType.type,
                    payload: program
                })
            }
        }
    }
}
export default Maps